module.exports = __webpack_public_path__ + "img/table-x-mark-20x20.5a8a1e58.svg";